import React, { useEffect, useState } from "react";
import "./styles.css";

/**
 * Инлайн-редактирование свободной заметки (nodes.comment / devices.comment) — по смыслу то же,
 * что label у скрипта: подпись от человека для человека.
 *
 * Клик по ячейке → input, Enter/blur — сохранить, Esc — отмена. Пустая строка сохраняется как
 * null: «заметки нет» и «заметка пустая» — одно состояние, и держать под него пустую строку
 * значит потом всюду сравнивать с двумя вариантами пустоты (см. миграцию колонки).
 *
 * Компонент НЕ ходит в API сам: он не знает, устройство перед ним или нода. Запрос и обновление
 * списка делает страница через onSave — она же решает, что считать успехом.
 *
 * @param value    текущее значение (может быть null)
 * @param canEdit  есть ли право на правку; без него — просто текст
 * @param onSave   async (value|null) => bool — true, если сохранилось
 */
export default function CommentCell({ value, canEdit, onSave }) {
    const [_editing, set_editing] = useState(false);
    const [_value, set_value] = useState(value || '');
    const [_saving, set_saving] = useState(false);

    // Значение могло приехать заново из перезагруженного списка — подхватываем, пока не правим.
    useEffect(() => { if (!_editing) set_value(value || ''); }, [value, _editing]);

    const save = async () => {
        if (_saving) return;
        const next = _value.trim();
        if (next === (value || '')) { set_editing(false); return; }

        set_saving(true);
        const ok = await onSave(next === '' ? null : next);
        set_saving(false);
        set_editing(false);
        if (!ok) set_value(value || '');
    };

    if (!canEdit) return <span className="comment-cell__text" title={value || undefined}>{value || '—'}</span>;

    if (!_editing) {
        return <span
            className={`comment-cell__editable ${value ? '' : 'comment-cell__editable_empty'}`}
            // Полный текст — в подсказке: в узкой колонке длинная заметка обрезается многоточием.
            title={value ? `${value}\n\nКлик — изменить` : 'Добавить заметку'}
            onClick={() => set_editing(true)}
        >{value || '—'}</span>;
    }

    return <input
        autoFocus
        className="input comment-cell__input"
        value={_value}
        disabled={_saving}
        placeholder="заметка"
        onChange={(e) => set_value(e.target.value)}
        onBlur={save}
        onKeyDown={(e) => {
            if (e.key === 'Enter') { e.preventDefault(); save(); }
            if (e.key === 'Escape') { set_value(value || ''); set_editing(false); }
        }}
    />;
}
